module.exports = {
  language: "繁体中文",

  //确认支付按钮
  components_confirmPay_btn: {
    notYet: "還沒有",
    waitingTips: "等待您的付款",
  },
  //买币阿根廷支付
  ArgentinaPay: {
    BankName: "銀行名稱",
    ChooseBank: "選擇您的銀行",
    selectcard: "請選擇銀行",
    BankAccount: "銀行賬戶",
    cardnumber: "請輸入正確的卡號",
    Bankcode: "銀行代碼",
    correctcode: "請輸入正確的密碼",
    ID: "ID",
    SelectBank: "選擇銀行",
    phone: "電話號碼",
    phoneTips: "無效的電話號碼!",
    paymentResultError: "銀行賬戶信息不正確。 請檢查並再次購買。",
    Choose: "選擇您的賬戶類型",
    chequing: "支票",
    Saving: "儲蓄",
    Amount: "數量:",
    AccountNumber: "帳號",
    BankCode: "銀行代碼",
    fullNameTips: "全名無效",
    idTips: "身份證號碼無效",
  },
  //买币结果页(暂时不用)
  // payResult: {
  //     //支付结果提示
  //     tipsText_40010: '明确卡信息错误',
  //     tipsText_40011: '明确卡信息错误',
  //     tipsText_40019: '明确卡信息错误',
  //     tipsText_40020: '卡余额不足',
  //     tipsText_40030: '卡受限-所属地区',
  //     tipsText_40031: '卡受限-发卡行限制',
  //     tipsText_40032: '卡受限-过期卡',
  //     tipsText_40033: '卡受限-发卡行限制-风险控制',
  //     tipsText_40034: '卡受限-风险控制',
  //     tipsText_40090: '待确认问题',
  // },

  //菜单
  menu: {
    home: "首頁",
    menu: "菜單",
    transactions: "歷史訂單記錄",
    language: "語言",
    privacy: "隱私政策",
    logOut: "退出",
    service: "服務條款",
    RouterMenu_experience: "登錄方可體驗全部功能",
    login_Youlogged: "你已經在登陸頁了",
    RouterMenu_Welcome: "歡迎來到Alchemy Pay!",
    history: "沒有交易記錄",
    loginOut_Dismiss: "取消",
    loginOut_title: "確定退出?",
  },

  //导航文案
  navTabTitle: {
    Completepayment: "完成支付",
  },

  //按钮组件
  button_components: {
    proceed: "繼續",
  },

  //---------------------------- 支付方式信息组件 ----------------------------
  PayMethodInfo_components: {
    title: "訂單摘要",
    title2: "您選擇的付款方式是",
  },
  //---------------------------- 扫码QR Code组件 ----------------------------
  QrCode_components: {
    title1: "支付",
    title2: "完成您的購買.",
    title3: "請打開您的支付申請，掃描下方二維碼完成支付.",
    copy: "複製",
  },
  //---------------------------- 钱包地址和网络信息组件 ----------------------------
  WalletAddress_components: {
    title1: "你的",
    title2: "錢包",
  },
  //---------------------------- 表单信息 ----------------------------
  formInfo: {
    //新增
    fullName_placeholder: "輸入全名",
    phone_title: "請輸入您的電話號碼",
    id_title: "輸入身份證號碼",
    id_placeholder1: "輸入",
    id_placeholder2: "數字身份證號碼",
    bankAccount_placeholder: "選擇您的賬戶類型",
    accountNumber_placeholder: "輸入22位身份證號碼",
    bankCode_placeholder: "輸入 3 位數的 ID 號",
    //vnd 选择bank code
    vnd_bankCode_placeholder: "選擇銀行代碼",
    select_id_placeholder: "選擇您的身份證類型",
  },

  vndChildren: {
    amount: "數量",
    oneTitle: " 前往銀行應用程序，掃描二維碼或手動輸入收款人ID",
    twoTitle: " 在消息框中填寫轉賬內容",
    threeTitle: " 進行匯款",
    Accountname: "帳戶顯示名稱",
    AccountID: "帳戶ID",
    Transfercontent: "傳輸內容",
  },

  //菲律宾页面
  phpPayment: {
    PaymentGuide: "付款指南",
    BillNumber: "數字彙款號碼",
    PAYSO1: "進入Gcash錢包，點擊“Bills”，選擇bill payment",
    PAYSO2: "搜索並選擇“PAYSO”",
    PAYSO3: "填寫這些信息，然後點擊【NEXT】】",
    Incorrect:
      "請確保您轉帳給我們的金額準確無誤。 錯誤的資訊或金額將導致訂單失敗或資金損失.",
  },

  // TRY银行转账表单信息
  TRY_form: {
    // TRY银行转账
    nationality_title: "輸入國籍",
    authCardNo_title: "輸入身份證號碼",
    firstName_title: "輸入名字",
    lastName_title: "輸入姓氏",
    address_title: "輸入地址",
    birthday_title: "輸入生日",
    authCardNo_tips: "身份證號碼無效",
    firstName_Tips: "名字無效",
    lastName_tips: "姓氏無效",
    address_tips: "地址無效",
    birthday_tips: "生日無效",
    address_Placeholder: "與身份證上的地址一致",
    ID_CARD: "身份證",
    DRIVER_LICENSE: "駕駛證",
    PASSPORT: "護照",
  },

  // KRW银行转账表单信息
  KRW_form: {
    // TRY银行转账
    nationality_title: "輸入國籍",
    authCardNo_title: "輸入身份證號碼",
    firstName_title: "輸入名字",
    lastName_title: "輸入姓氏",
    address_title: "輸入地址",
    birthday_title: "輸入生日（日/月/年）",
    authCardNo_tips: "身份證號碼無效",
    firstName_Tips: "名字無效",
    lastName_tips: "姓氏無效",
    address_tips: "地址無效",
    birthday_tips: "生日無效",
    address_Placeholder: "與身份證上的地址一致",
    RESIDENT_REGISTRATION_NUMBER: "身份證",
    DRIVER_LICENSE: "駕駛證",
    PASSPORT_NUMBER: "護照",
    ALIEN_REGISTRATION_NUMBER: "居住證",
    DOMESTIC_RESIDENCE_REPORT_NUMBER: "住址登記證",
  },

  //---------------------------- 用户支付信息组件 ----------------------------
  TraderInformation: {
    title: "交易者信息",
  },

  //---------------------------- 银行转账收银台 ----------------------------
  cashierDesk_bankTransfer: {
    tiemOut: "訂單將在{0}{1}後取消",
    PleasePay: "請付款",
    title1: "打開您的銀行申請。輸入此參考號",
    title2: "輸入賬號註冊信息",
    CLABEinterbancaria: "CLABE 銀行間：",
    Destinationbank: "目的地銀行：",
    Beneficiary: "受益人：",
    Payamount: "支付金額：",
    title3:
      "如果您的付款長期未完成，我們建議您將付款文件上傳至我們的客服。 這將加快我們確認您的付款的速度。",
  },

  //登陆页
  loginPage: {
    enterEmail: "請告知您的電子郵件地址",
    enterEmail1: "這是否為您的電子郵件地址？",
    emailanother: "使用其他電子郵件地址登錄",
    emailNotyou: "不是您?",
    codeTitle1: "請輸入您剛剛收到的登錄代碼",
  },

  //买币历史订单页+买币订单详情页
  buyHistory: {
    buyPrice: " 價格 ",
    buyTotal: "總計 ",
    buyOrderID: "訂單編號",
    buyOrdeTime: "訂單時間",
    buyPaymentTime: "支付時間",
    buyPayerAccount: "付款賬戶",
    buyCompleted: "完成",
    buyFailed: "失敗",
    buyClosed: "已關閉",
    history_noListText: "無交易",
    history_noListButton: "立即買入NFT",
    history_noMore: "無更多交易記錄",
  },

  //买币信用卡表单组件
  components_buyForm: {
    formTitle: "輸入您的銀行卡信息。",
    firstName: "名字",
    lastName: "姓氏",
    nameTips: "無效名字!",
    cardNumber: "卡號",
    cardNumTips: "請輸入正確的卡信息。",
    expirationDate: "有效日期",
    dataTips: "有效日期輸入有誤",
    cvv: "CVV",
    cvvTips: "請輸入正確的CVV",
  },

  //确认订单页 - 信用卡
  creditCard: {
    payingWith: "支付方式",
    card: "銀行卡",
    cvv: "CVV",
  },

  //确定订单页 - 巴西支付
  configPay_brl: {
    phoneNumber: "手機號碼",
    fullName: "姓名",
    formTitle: "輸入您的詳細信息",
    code_tips: "通過PIX掃描二維碼以完成付款。",
    name_tips: "無效姓名!",
    id_tips: "無效Id!",
    number_tips: "無效手機號碼!",
    selectCountry: "選擇國家",
  },

  //确认订单页 - 墨西哥
  opmPayment: {
    banco: "Banco",
  },

  components_payConfig: {
    title_THB: "正在支付",
    button_THB: "查詢訂單",
    button_timeOut: "返回首頁",
    button_timeOut1: "返回首頁",
    double: "请不要重复付款",
    completed: "請確認您的轉帳已完成。",
    timeorder: "此訂單已超時。",
    checkout: "您確定離開結帳櫃檯嗎？",
    buttonLeave: "關閉訂單",
  },

  //选择支付方式页
  buyPayWay: {
    BINANCEPAY: "BINANCE PAY",
    qrCode: "QR Code",
    Khipu: "銀行轉帳",
    ThaiQR: "ThaiQR",
    ChangeCard: "更改銀行卡",
    towMethod: "更改付款方式",
    Philippines: "銀行轉帳",
    saas: "PayNow",
    recentlyUsed: "保存的付款方式",
    paymentMethod: "添加新的付款方式",
    rampFee: "加工費",
    card: "銀行卡",
    card1: "銀行卡",
    creditCard: "信用卡",
    bankTransfer: "即時支付",
    bancoTransfer: "銀行轉賬",
    opm: "SPEI(OPM)",
    virtualAccount: "銀行轉帳",
    eWallet: "電子錢包",
    binancePay: "BINANCE PAY",
    applePay: "Apple Pay",
    googlePay: "Google Pay",
    promptPay: "Prompt Pay",
    addCardTitle: "添加新卡",
    useCardTitle: "使用新卡",
    edit: "編輯",
    cancel: "取消",
    support: "支持",
    cardLimitTips: "已達到6張卡的限製",
    kaKaoPay: "KaKao Pay",
    GCash: "銀行轉帳",
    touchNGo: "Touch n go",
    payNow: "Pay Now",
    proceed: "繼續",
    Unavaible: "無法使用",
    limit: "限度",
    deleteTips: "成功刪除",
  },

  nav: {
    //买币确认订单文案提示
    buyConfigPaytitle: "繼續，即表示您同意我們的 ",

    /**
     * 按钮文案
     */
    Continue: "繼續",
    Confirm: "確認",
    ConfirmPayment: "確認付款",
    queryOderState: "我已經完成付款",
    Proceed: "進行",
    //风险账户文案
    accountTraded: "該賬戶存在風險，此刻不可進行交易。",

    /**
     * 路由
     */
    routerName_Transactions: "交易記錄",
    routerName_receivingMode: "接收",
    routerName_paymentMethod: "選擇付款方式",
    routerName_basisIdAuth: "basis-Id-Auth",
    routerName_creditCardConfig: "確認付款",
    routerName_buyPayment: "付款",
    routerName_buyOtherWayPay: "確認付款",
    routerName_paymentResult: "付款結果",
    routerName_kycOnfido: "身份驗證",
    routerName_kycSumsub: "身份證明&自拍&地址證明",

    /**
     * 菜单
     */
    login: "登錄",
    login_required: "格式錯誤.",
    login_necessary: "必要的",

    loginTitle1: "通過Alchemy Pay結算",
    loginTitle2: "在數以百計的加密幣APP中最快捷、安全的結算方式。",
    codeTitle2: "未收到？",
    codeTitle3: "將發送新的確認碼",
    codeSecond: "s",
    code_and: "和",
    code_name2: "隱私政策",
    code_text: "我同意Alchemy Pay之",

    /**
     * 组件
     */
    networkAddress_components_title: "地址",

    /**
     * 首页
     */
    copyTips: "複製成功",

    //买币 - 确认订单 - 国际卡
    buy_configPay_title1: "支付方式",

    //买币 - 确认订单 - 印尼支付
    buy_configPayIDR_va_title: "銀行",
    buy_configPayIDR_va_codeTitle: "支付碼",
    buy_configPayIDR_codeTips: "掃描二維碼以完成支付",
    buy_configPayIDR_ovo_phoneTips: "打開 OVO 應用程序完成支付。",

    //菜单栏语言
    RouterMenu_Welcome: "歡迎來到Alchemy Pay!",
    RouterMenu_history: "沒有交易記錄",

    history_state_Complete: "完成",
    history_state_Processing: "正在處理",
    history_state_Transfer: "加密幣已發送",
    history_listTitle1: "訂單號",
    history_listTitle2: "交易數量",
    history_listTitle3: "服務識別號",
    fee_listTitle_price: "幣價",
    sell_order_title: "狀態-内容",
    fee_tips: "基於支付方式",
    search_components_Popular: "廣受歡迎",
    search_components_All: "全部",
    search_components_placeHolder: "在此處搜索… ",
    result_stateTo4_your: "您的",
    result_stateTo4: "訂單正在處理中，很快將發送到您指定的地址。",
    result_stateTo5: "已轉至您的錢包地址。",
    result_returnText_merchant: " 返回",
    buy_configPayIDR_ovo_title: "OVO電話",
    login_getCode: "重新發送驗證碼",
    login_VerifyCode: "請輸入六位數驗證碼",
    login_Agreement: "請勾選用戶協定",
  },

  //确认订单通用
  confirmOrder: {
    pleasePay: "請付款",
  },

  //首页
  homePage: {
    purchaseNFT: "購買NFT",
    item: "名稱",
    quantity: "數量",
    youPay: "您付款",
    proceedBuy: "繼續 · 買入 ",
    selectCurrency: "選擇貨幣",
    tiemErrToast: "訂單超時,無法下一步",
    USDTips: "暫不支持USD,請選擇其他法幣",
  },

  //交易历史
  transactionHistory: {
    buy: "購買",
    item: "名稱",
    price: "價格",
    quantity: "數量",
    total: "總計",
    uniqueId: "唯一身份",
    loading: "加載中",
    loadingFailed: "加載失敗",
  },
  //等待组件
  buypayWait: {
    Processing: "進行中",
    progress: "訂單進行中",
    purchase: "訂單進行中購買此商品 ",
    transaction: "完成此最終交易!",
  },
  //结果页
  payResult: {
    buttonText: "返回到 ",
    goHistory: "查看訂單歷史記錄",
    closed1: "此訂單已過期.",
    closed2: "請再次下單",
    failed1: "付款失敗!",
    failed2: "信息有誤，已被銀行拒絕.",
    failed1010: "付款金額與當前付款方式限制不符",
    success1: "非常感謝!",
    success2: "購買成功.",
    success3: "我們已經向您發送了一封包含訂單詳細信息的電子郵件.",
    waitTips: "等待付款",
  },

  //费用信息组件
  buyFee_components: {
    codeSecond: "s",
    title: "購買 NFT",
    rampFee: "加工費",
    rampFeeTips: "低至",
    networkFee: "網絡費",
    tips: "這由AlchemyPay收取，以支付與支付處理相關的費用。這可能因您稍後選擇的付款方式而異。",
  },
  // kyc_onfido
  kycAlert: {
    waiting_msg: "您的證件和照片驗證正在審核中：",
    success_msg: "身份驗證成功",
    failure_msg: "重新提交相關文件",
  },
  kycStatus: {
    account: "帳戶：",
    login_time: "上次登錄時間：",
    verify_succeeded: {
      tips: "身份驗證成功",
      content:
        "恭喜！您提交的所有文件均已通過審核。您的日交易限額已提高至相當於 {0} 的額度。",
      process: "繼續交易",
    },
    verify_exception: {
      tips: "重新提交相關文件",
      update_document: "更新文件",
    },
    verify_failed: {
      tips: "身份驗證未通過",
    },
    verify_waiting: {
      received_documents: "我們已收到您的身份驗證文件。",
      notify_you:
        "審核結果將通過電子郵件通知您，通常需要 5 至 10 分鐘。在極少數情況下，將進行人工復審。人工復審將在 24 小時內完成。",
      leave: "現在離開",
      under_review: "審核中...",
      estimated_time: "預計等待時間：",
      waiting_time: "您已等待：",
      reviewed_now: "您提交的文件正在進行審核。",
    },
  },
  //kyc验证页面
  kycVerificationFonts: {
    kycminutestitle: "請驗證您的身份。通常需要大約2分鐘。",
    kycPrepareyour: "準備好您的身份證件",
    kycminutesdocument: "持身份證件準備自拍",
    kycButtonminutes: "開始驗證",
    kyccompleted1: "恭喜！",
    kyccompleted2: "驗證通過。",
    kycButtoncompleted: "繼續支付",
    kycPayLimitUpTips: "付款限額最高為",
    kycError: "您的驗證失敗。",
    kycRiskAccount: "該賬戶存在風險，此刻不可進行交易。",
    kycButtonError: " 返回首頁 ",
    kycButtonTryAgain: "再試一次 ",

    kyc2_startTitle: "請提供您的地址材料。",
    kycErrorTips: "請確保您的地址真實可靠",
    kycErrorTryAgain_title: "您的驗證失敗。",
    kycErrorTryAgain_tipsTitle: "請確保",
    kycErrorTryAgain_tips1: "您提交了自己的身份證件。",
    kycErrorTryAgain_tips2: "您身份證件上的姓名與您付款的持卡人姓名相同。",
    kycErrorTryAgain_tips3: "您沒有使用多個身份證件進行KYC驗證。",
  },
};
